// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"14191938","92":"9200421e","126":"470b14e1","177":"0fb0a643","326":"f42be8f4","442":"a49aca6a","579":"4f910725","608":"40a5b316","623":"e667b8e3","719":"2e0a5b71","838":"25a99d88","925":"7bcd34d6"}[chunkId] + ".chunk.js";
};